export default "__VITE_ASSET__BOsh8jQt__"